import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import CreateClassLink from "../CreateClassLink/CreateClassLink";
import axios from "../../../axios";
import "../../styles/index.css";
import { SubStdSelContext } from "../../../SubStdSelContext";
import { IP } from "../../../internalServer";
import { toast } from "react-toastify";
import JoinNowInstructions from "./JoinNowInstructions";
import { Clock3, ExternalLink, Hand } from "lucide-react";
import "./joinNowInstruction.css";

/**
 * Displays AddClassMaterial for day view
 * @param {*} param0
 * @returns
 * @param {*} param0
 * @returns
 */

const mapStateToProps = (state) => ({
  inc: state.redres,
  dec: state.redres1,
  ovr: state.redres2,
});

const Upcoming = ({
  event,
  inc,
  dec,
  ovr,
  refetch1,
  SDate,
  EDate,
  setIsCreateLinkClicked,
}) => {
  const general_role = localStorage.getItem("general_role");
  const jsonRole_Geinformation = JSON.parse(general_role);
  let Teacher_Id = JSON.parse(localStorage.getItem("Teacher_id"));
  const {
    secSelectedOption,
    stdSelectedOption,
    teacherDCM,
    secSelectedOptionName,
    stdSelectedOptionName,
  } = useContext(SubStdSelContext);
  const [click1, setClick1] = useState(false);
  const [bookChapterList, setBookChapterList] = useState([]);
  const [joinNow, setJoinNow] = useState(false);
  const [lunch, setLunch] = useState(false);
  const [editfunction, setEditFunction] = useState(false);
  const [openInstruction, setOpenInstruction] = useState(false);
  const [meetingUrl, setMeetingUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showModalInstruction, setShowModalInstruction] = useState(false);

  const onClassMaterialClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  const teacherId = JSON.parse(localStorage.getItem("Teacher_id"));

  const foundItem = event?.Events?.find((item) => item.name === "bbb_lecture");

  const schoolInfo = JSON.parse(localStorage.getItem("UserInformation"));

  const IsYoutubeliveLectureEnabled =
    schoolInfo.school.liveClassType === "broadcast" ? true : false;

  useEffect(() => {
    if (ovr?.name === "General Teacher") {
      jsonRole_Geinformation.forEach((element) => {
        if (element.standard_id.id === inc.id) {
          if (element.section_id.id === dec.id) {
            element.subjects_id.forEach((element) => {
              if (element.name === event.Subject) {
                setEditFunction(true);
              }
            });
          }
        }
      });
    } else {
      setEditFunction(true);
    }
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        setJoinNow(true);
      }
    });
  });
  const timeDiffWithCurrentTime = (endTimeString) => {
    var currentTime = new Date();
    var endTime = new Date(endTimeString);
    var diffInMs = endTime.getTime() - currentTime.getTime();
    var diffInMins = diffInMs / 60000;
    var finalResult = Math.round(diffInMins + 5);
    return finalResult;
  };

  const onJoinClick = async () => {
    setIsLoading(true);
    try {
      if (IsYoutubeliveLectureEnabled) {
        setOpenInstruction(true);
        return;
      }

      await joinnow_helper();
      setShowModalInstruction(false);
    }catch(e){
      console.log(e)
    }finally{
       setIsLoading(false);
    }
  };


  const joinnow_helper = async () => {
    try {
      setIsCreateLinkClicked(true);

      const teacherJoinLink = await onJoinNowClick();

      if (!teacherJoinLink) {
        setIsLoading(false);
        return;
      }

      window.open(teacherJoinLink, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  let _id;
  const onJoinNowClick = async () => {
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        setJoinNow(true);
        _id = element.value;
      }
    });
    let res = await axios.get(
      `/api/v1/videoConference/classes/getInfo?class_id=${_id}`,
    );
    res = res.data.data;



    let newRes = {
      standard_id: stdSelectedOption,
      teacher_id: res.teacher,
      subject_id: res.subject,
      section_id: secSelectedOption,
      chapter_id: res.chapter,
      book_id: res.book,
      name: res.name,
      description: res.description,
      any_to_start_session: res.any_to_start_session,
      logo: `${IP}public/upload/logo/Logo.png`,
      record: true,
      mute_on_start: res.mute_on_start,
      welcome_message: res?.welcome_message,
      allow_mods_to_unmute_users: res.allow_mods_to_unmute_users,
      wallpaper:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      dark_color: "##ffff",
      logout_url:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      light_color: "#7BDEFF",
      primary_color: "blue",
      meeting_layout: "SMART_LAYOUT", //"VIDEO_FOCUS",
      lock_settings_disable_private_chat:
        res.lock_settings_disable_private_chat,
      require_moderator_approval: res.require_moderator_approval,
      auto_join: res.auto_join,
      webcams_only_for_moderator: true,
      lockSettingsHideUserList: true,
      allowedStudentsMode: res.allowedStudentsMode,
      allowedStudents: res.allowedStudents,
      banner_color: "#00000",
      banner_text: "Breathe4School",

      duration: timeDiffWithCurrentTime(event.EndTime),
      add_to_live_session: res.addToLiveSession,
    };
    try {
      const res = await axios.post(
        `/api/v1/videoConference/classes/create?school_id=${schoolId}`,
        newRes,
      );

      if (res.data.status !== true) {
        toast.error("Failed to create video class.");
        return; // Don't proceed to second API
      }

      const _id = res.data.data.id;
      const viewer_name = JSON.parse(localStorage.getItem("UserName"));
      try {
        const startRes = await axios.get(
          `/api/v1/videoConference/classes/start/${_id}?moderator_name=${viewer_name}&school_id=${schoolId}`,
        );
        console.log("startRes.data", startRes.data);

        if (startRes.data.status === true) {
          return startRes.data.data;
        } else {
          toast.error("Failed to start video class.");
        }
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const lecture_date = new Date(event.StartTime).toISOString().split("T")[0];
  const lecture_time = new Date(event.StartTime).toTimeString().slice(0, 5);

  const onJoinYtbNowClick = async () => {
    console.log("onJoinYtbNowClick");
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        setJoinNow(true);
        _id = element.value;
      }
    });
    let res = await axios.get(
      `/api/v1/videoConference/classes/getInfo?class_id=${_id}`,
    );
    res = res.data.data;
    console.log(res, "res for joon now click");
    let newRes = {
      standard_id: stdSelectedOption,
      teacher_id: res.teacher,
      subject_id: res.subject,
      section_id: secSelectedOption,
      chapter_id: res.chapter,
      book_id: res.book,
      name: res.name,
      description: res.description,
      any_to_start_session: res.any_to_start_session,
      logo: `${IP}public/upload/logo/Logo.png`,
      record: true,
      mute_on_start: res.mute_on_start,
      welcome_message: res?.welcome_message,
      allow_mods_to_unmute_users: res.allow_mods_to_unmute_users,
      wallpaper:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      dark_color: "##ffff",
      logout_url:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      light_color: "#7BDEFF",
      primary_color: "blue",
      meeting_layout: "SMART_LAYOUT", //"VIDEO_FOCUS",
      lock_settings_disable_private_chat:
        res.lock_settings_disable_private_chat,
      require_moderator_approval: res.require_moderator_approval,
      auto_join: res.auto_join,
      webcams_only_for_moderator: true,
      lockSettingsHideUserList: true,
      banner_color: "#00000",
      banner_text: "Breathe4School",
      duration: timeDiffWithCurrentTime(event.EndTime),
      add_to_live_session: res.addToLiveSession,
      lecture_date: lecture_date,
      lecture_time: lecture_time,
      channelId: res.channelId,
    };
    try {
      const res = await axios.post(
        `/api/v1/videoConference/classes/create?school_id=${schoolId}`,
        newRes,
      );

      if (res.data.status !== true) {
        toast.error("Failed to create video class.");
        return; // Don't proceed to second API
      }

      const _id = res.data.data.id;
      const viewer_name = JSON.parse(localStorage.getItem("UserName"));
      try {
        const startRes = await axios.get(
          `/api/v1/videoConference/classes/start/${_id}?moderator_name=${viewer_name}&school_id=${schoolId}`,
        );

        if (startRes.data.status === true) {
          return startRes.data.data;
        } else {
          toast.error("Failed to start video class.");
        }
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${stdSelectedOption}&section_id=${secSelectedOption}&subject_id=${event.Subject_id}&timetableSessionId=${timeTableSessionId}`,
      );
      if (chapters) {
        setBookChapterList(chapters.data.data[0].bookInfo);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong while books and chapter fetching");
    }
  };

  const onInstructionContinue = async () => {
    setOpenInstruction(false);
    setIsLoading(true);

    try {
      const teacherJoinLink = await onJoinYtbNowClick();

      if (teacherJoinLink) {
        window.open(teacherJoinLink, "_blank", "noopener,noreferrer");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDetails();
  }, [click1]);

  return (
    <>
      <div
        className="col d-flex justify-content-between align-items-center gap-4"
        style={{ cursor: "pointer" }}
      >
        <div>
          {foundItem && (
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowModalInstruction(true);
              }}
              className="btn d-flex align-items-center justify-content-center px-1 py-1 fw-bold text-uppercase shadow-sm"
              style={{
                backgroundColor: isLoading ? "#e0e0e0" : "#fff",
                color: isLoading ? "#888" : "#4169e1",
                border: `2px solid #4169e1"`,
                borderRadius: "50px",
                fontSize: "10px",
                letterSpacing: "0.5px",
                transition: "all 0.3s ease",
                cursor: isLoading ? "not-allowed" : "pointer",
                opacity: isLoading ? 0.6 : 1,
              }}
            >
              Join Now
            </button>
          )}
        </div>
      </div>
      {openInstruction && (
        <JoinNowInstructions
          openInstruction={openInstruction}
          setOpenInstruction={setOpenInstruction}
          onContinue={onInstructionContinue}
        />
      )}
      {showModalInstruction && (
        <div className="modal-overlay-live">
          <div className="modal-container-live">
            {/* Title */}
            <h2 className="modal-title">💻 Live Class</h2>

            {/* Description */}
            <p className="modal-description">
              The Live Class will open in your browser.
            </p>

            {/* Info Box */}
            <div className="info-box">
              <div className="info-item">
                <Clock3 className="info-icon info-icon-orange" />
                <p className="info-text">
                  On slow networks, it may take up to <b>2 minutes.</b>
                </p>
              </div>

              <div className="info-item">
                <Hand className="info-icon info-icon-red" />
                <p className="info-text">
                  Please wait and avoid tapping <b>Continue</b> again.
                </p>
              </div>

              <div className="info-item">
                <ExternalLink className="info-icon info-icon-blue " />
                <p className="info-text w-75">
                  If you retry later, close any previously opened Live <br/> Class
                  browser tab.
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="button-container">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowModalInstruction(false);
                }}
                className="btn-close-live"
              >
                Close
              </button>
              <button
                disabled={isLoading}
                onClick={(e) => {
                  e.stopPropagation();
                  onJoinClick();
                }}
                className="btn-continue"
              >
                {isLoading ? "Joining..." : "Continue"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default connect(mapStateToProps)(Upcoming);
